/** @format */

import React, { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { TableBody, TableFooter, TableHead, TableRow } from '@material-ui/core';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import TableCell from '@material-ui/core/TableCell';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { PliCbd2CollectionInterface } from '../../interfaces/collections/PliCbd2CollectionInterface';
import Pager from '../../components/Adescom/PagerRange';
import PliCbd2Interface from '../../interfaces/platform/PliCbd2Interface';
import I18n from '../../components/Translate/I18n';
import { AcqOperator } from '../../interfaces/platform/AcqOperator';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { HeaderCheckBoxSelectListElement } from '../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { AcqOperatorLoader } from '../../modules/mnp/AcqOperatorLoader';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { MnpAllRow } from './lib/MnpAllRow';
import { MnpEventType } from './MnpEventType';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterManager } from '../../modules/filter/FilterManager';
import FilterList from '../../components/Filter/FilterList';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import i18next from 'i18next';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import PaperedTable from '../../components/Table/PaperedTable';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import {NotificationHelper} from "../../helpers/NotificationHelper";

const _ = require('underscore');

interface MnpAllListProps {
    classes: any;
    dispatch: any;

    showMainLoader(value: boolean): void;

    headerFilterElementHasValue?: boolean;
    headerFilterElementName?: string;
}

interface MnpAllListState {
    filters: Array<Filter>;
    orders: Array<Order>;
    items: PliCbd2CollectionInterface | null;
    acqOperators: Array<AcqOperator>;
    platformResellers: Array<HeaderCheckBoxSelectListElement>;
    acqOperatorHeader: Array<HeaderCheckBoxSelectListElement>;
    showClearFilterButton: boolean;
    csvDownload: null;
    activeRow: number;
}

interface MnpCaseCsvCols {
    mnpCaseId: string;
    state: string;
    msisdn: string;
    partner: string;
    portingDate: string;
    donor: string;
    donorName: string;
    recipient: string;
    recipientName: string;
}

class MnpAllList extends PureComponent<MnpAllListProps, MnpAllListState> {
    private itemLoader: ItemLoaders;
    private platformResellersLoader: PlatformResellerLoader;
    private acqOperatorLoader: AcqOperatorLoader;
    private mnpEventType: MnpEventType;
    private filterManage: FilterManager;

    constructor(props: MnpAllListProps, context: MnpAllListState) {
        super(props, context);

        this.state = {
            filters: [],
            orders: [],
            items: null,
            acqOperators: [],
            platformResellers: [],
            acqOperatorHeader: [],
            showClearFilterButton: false,
            csvDownload: null,
            activeRow: 0,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.platformResellersLoader = new PlatformResellerLoader(this.itemLoader);
        this.acqOperatorLoader = new AcqOperatorLoader(this.itemLoader);
        this.mnpEventType = new MnpEventType();
        this.filterManage = new FilterManager();
    }

    componentDidMount(): void {
        this.loadAcqOperators();
        this.loadPlatformResellers();
    }

    componentDidUpdate(prevProps: Readonly<MnpAllListProps>, prevState: Readonly<MnpAllListState>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    loadPlatformResellers = (): void => {
        this.platformResellersLoader.loadPlatformResellers({
            callback: () => {
                this.setState({ platformResellers: this.platformResellersLoader.getPlatformResellersHeaderList() });
            },
            filters: [{ name: 'deleted', value: 0 }],
        });
    };

    loadAcqOperators = (): void => {
        this.acqOperatorLoader.loadAcqOperators({
            callback: () => {
                this.setState(
                    {
                        acqOperators: this.acqOperatorLoader.getAcqOperators(),
                        acqOperatorHeader: this.acqOperatorLoader.getAcqOperatorsHeaderList(),
                    },
                    () => {
                        this.setDefaultFilter((): void => {});
                    }
                );
            },
        });
    };

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                filters: [{ name: 'eventTypeId', value: '1,2,3,4' }],
                orders: [{ name: 'searchEventDateTime', value: 'desc' }],
            },
            (): void => {
                callback();
                this.firstLoad();
            }
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    updateOrderListRecipient = (orders: Array<Order>): void => {
        this.setState({ orders: orders }, this.firstLoad);
    };

    updateFilterAcqOperatorListRecipient = (filters: Array<Filter>): void => {
        this.setState({ filters: this.acqOperatorLoader.updateFilterRptSearch(filters, 'recipient') });
    };

    updateFilterAcqOperatorListDonor = (filters: Array<Filter>): void => {
        this.setState({ filters: this.acqOperatorLoader.updateFilterRptSearch(filters, 'donor') });
    };

    updateFilterOnEmtyList = (fieldName: string): string | Array<number> | Array<string> | Array<boolean> => {
        if (fieldName === 'eventTypeId') {
            return [1, 2, 3, 4];
        }
        return '';
    };

    paginationCallbackFunction = (uri: string): void => {
        this.props.showMainLoader(true);
        this.itemLoader.paginationCallWithCallback(
            uri,
            'load_pli_cbd_2_list_e13_in',
            (data: PliCbd2CollectionInterface): void => {
                this.setState({ items: data });
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        const { dispatch } = this.props;
        this.props.showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/pli_cbd2_cases')),
            'load_pli_cbd_2_list_e13_in',
            filters,
            orders,
            (data: PliCbd2CollectionInterface): void => {
                this.setState({ items: data, csvDownload: null });
                this.props.showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    exportToCsv = (): void => {
        const { filters, orders ,items} = this.state;
        const{ dispatch} = this.props;
        if(items && !items['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        const extendFilter = _.clone(filters);
        extendFilter.push({ name: 'pagination', value: 'false' });
        this.props.showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/pli_cbd2_cases')),
            'load_pli_cbd_2_list_e13_in_csv',
            extendFilter,
            orders,
            (data: PliCbd2CollectionInterface): void => {
                const csvList = this.prepareCsvData(data);
                const options = {
                    filename: 'pliCbd2Report_' + moment().format('YYYYMMDD[_]HHmm'),
                    fieldSeparator: ';',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    showLabels: true,
                    showTitle: false,
                    title: 'PliCbd2 report',
                    useTextFile: false,
                    useBom: true,
                    useKeysAsHeaders: false,
                    headers: [
                        i18next.t('mnp_cases:h.mnpcaseid'),
                        i18next.t('mnp_cases:h.case_event_type'),
                        i18next.t('mnp_cases:h.msisdn'),
                        i18next.t('mnp_cases:h.partner'),
                        i18next.t('mnp_cases:h.port_in_date'),
                        i18next.t('mnp_cases:h.donor'),
                        i18next.t('mnp_cases:h.donor_name'),
                        i18next.t('mnp_cases:h.recipient'),
                        i18next.t('mnp_cases:h.recipient_name'),
                    ],
                };
                this.props.showMainLoader(false);
                const exportCsv = new ExportToCsv(options);
                exportCsv.generateCsv(csvList);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    prepareCsvData = (data: PliCbd2CollectionInterface): Array<MnpCaseCsvCols> => {
        const csvList: Array<MnpCaseCsvCols> = [];
        if (data['hydra:member']) {
            data['hydra:member'].map((mnpCase: PliCbd2Interface) => {
                let eventType = '';
                let partnerName: string | null = '';
                if (mnpCase.platformReseller) {
                    eventType = this.mnpEventType.getI18Name(mnpCase.eventType, true);
                    partnerName = this.platformResellersLoader.getPlatformResellerNameByUri(mnpCase.platformReseller);
                } else if (mnpCase.recipientPlatformReseller) {
                    eventType = this.mnpEventType.getI18Name(mnpCase.eventType, false);
                    partnerName = this.platformResellersLoader.getPlatformResellerNameByUri(mnpCase.recipientPlatformReseller);
                }
                const donorName = this.acqOperatorLoader.getOperatorNameByRpt(mnpCase.donor, true) ?? '';
                const recipientName = this.acqOperatorLoader.getOperatorNameByRpt(mnpCase.recipient, true) ?? '';
                csvList.push({
                    mnpCaseId: mnpCase.caseId,
                    state: i18next.t(eventType),
                    msisdn: mnpCase.msisdn ? mnpCase.msisdn : '',
                    partner: partnerName ? partnerName : '',
                    portingDate: mnpCase.searchEventDateTime ? DateHelperTs.format(mnpCase.searchEventDateTime, 'YYYY-MM-DD') : '',
                    donor: mnpCase.donor ? mnpCase.donor : '',
                    donorName: donorName,
                    recipient: mnpCase.recipient ? mnpCase.recipient : '',
                    recipientName: recipientName,
                });
            });
        }
        return csvList;
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
        });
    };

    render(): ReactNode {
        const { classes } = this.props;
        const { filters, orders, items, platformResellers, acqOperatorHeader, showClearFilterButton, activeRow } = this.state;

        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12}  className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        size={'lg'}
                                        label="general:common.search"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size={'lg'}
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size={'lg'}
                                    />
                                </GridItem>
                                <FilterList />
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.mnpcaseid"
                                        fieldName="caseId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        setStringToUpper={true}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.case_event_type"
                                        fieldName="eventTypeId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={this.mnpEventType.getEventTypes()}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        updateFilterOnEmtyList={this.updateFilterOnEmtyList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.msisdn"
                                        fieldName="msisdn"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.partner"
                                        fieldName="partnerPlatformResellerId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={platformResellers}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.port_in_date"
                                        fieldName="searchEventDateTime"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.donor"
                                        fieldName="donor"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={acqOperatorHeader}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderListRecipient}
                                        updateFilterList={this.updateFilterAcqOperatorListDonor}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="mnp_cases:h.recipient"
                                        fieldName="recipient"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={acqOperatorHeader}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderListRecipient}
                                        updateFilterList={this.updateFilterAcqOperatorListRecipient}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items &&
                                items['hydra:member'] &&
                                items['hydra:member'].map((item: PliCbd2Interface) => {
                                    let rowActiveColor = 'white';
                                    if (activeRow === item.id) {
                                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                    }
                                    return (
                                        <MnpAllRow
                                            key={'plicbd2_' + item.id}
                                            pliCbd2={item}
                                            classes={classes}
                                            acqOperators={this.acqOperatorLoader}
                                            platformResellerLoader={this.platformResellersLoader}
                                            mnpEventType={this.mnpEventType}
                                            setActiveRow={this.setActiveRow}
                                            rowActiveColor={rowActiveColor}
                                        />
                                    );
                                })}
                            {items && items['hydra:member'] && items['hydra:member'].length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <I18n trans="mnp_cases:h.no_result" />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={5}>
                                    {items && items['hydra:view'] && <Pager callback={this.paginationCallbackFunction} views={items} />}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(oplAppStyle))(MnpAllList);
